(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-upsell-add]');
    if (!btn) return;
    event.preventDefault();

    var row = btn.closest('.cart-upsell__item');
    var select = row ? row.querySelector('.cart-upsell__select') : null;
    var variantId = Number(select ? select.value : btn.dataset.variantId);
    if (!variantId) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var drawer = btn.closest('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    try {
      var res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
      if (useDrawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error('Cart add-on error:', err);
      btn.textContent = 'Unavailable';
      setTimeout(function () {
        btn.textContent = label;
        btn.disabled = false;
      }, 2000);
    }
  });
})();
